var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59659 5.03383L10.9998 9.43709L15.3803 5.05664C15.477 4.95366 15.5936 4.87127 15.723 4.81442C15.8524 4.75758 15.9919 4.72744 16.1332 4.72583C16.4357 4.72583 16.7259 4.84601 16.9398 5.05995C17.1537 5.27388 17.2739 5.56403 17.2739 5.86657C17.2766 6.00643 17.2506 6.14535 17.1977 6.27482C17.1447 6.40429 17.0658 6.52157 16.9659 6.61946L12.5284 10.9999L16.9659 15.4374C17.1539 15.6213 17.2642 15.8704 17.2739 16.1332C17.2739 16.4358 17.1537 16.7259 16.9398 16.9399C16.7259 17.1538 16.4357 17.274 16.1332 17.274C15.9878 17.28 15.8427 17.2557 15.7072 17.2027C15.5717 17.1497 15.4487 17.0691 15.3461 16.966L10.9998 12.5627L6.60799 16.9546C6.51161 17.0541 6.39646 17.1336 6.2692 17.1884C6.14193 17.2432 6.00507 17.2723 5.86651 17.274C5.56397 17.274 5.27382 17.1538 5.05989 16.9399C4.84596 16.7259 4.72577 16.4358 4.72577 16.1332C4.72311 15.9934 4.74906 15.8545 4.80202 15.725C4.85499 15.5955 4.93385 15.4782 5.03377 15.3803L9.47125 10.9999L5.03377 6.56242C4.84576 6.37849 4.73551 6.12941 4.72577 5.86657C4.72577 5.56403 4.84596 5.27388 5.05989 5.05995C5.27382 4.84601 5.56397 4.72583 5.86651 4.72583C6.14029 4.72925 6.40266 4.8399 6.59659 5.03383Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectAction);
export default __webpack_public_path__ + "static/media/rejectAction.f5e46c9a95598127844b52ed077e610e.svg";
export { ForwardRef as ReactComponent };